/**
 * Vertical scale bar gradient next to the WMS preview, aligned with INDEX_LEGENDS (openstreetmap).
 */

import {INDEX_LEGENDS, LegendItem} from '@components/openstreetmap/legend-configs';

const DEFAULT_GRADIENT = 'linear-gradient(180deg, #22c55e, #eab308, #ef4444)';

function legendRowsForIndex(selectedIndexValue: string): LegendItem[] {
  const L = INDEX_LEGENDS as Record<string, LegendItem[]>;
  const k = String(selectedIndexValue || 'Ndvi').trim();
  if (L[k]?.length) {
    return L[k];
  }
  const titled = k.length ? k[0].toUpperCase() + k.slice(1).toLowerCase() : 'Ndvi';
  if (L[titled]?.length) {
    return L[titled];
  }
  return L['Ndvi'] ?? [];
}

function hexStopsFromLegendItems(items: LegendItem[]): string[] {
  const stops: string[] = [];
  for (const it of items) {
    const c = String(it.color ?? '').trim();
    if (!c) {
      continue;
    }
    const hexes = c.match(/#[0-9A-Fa-f]{6}\b|#[0-9A-Fa-f]{3}\b/g);
    if (!hexes?.length) {
      continue;
    }
    for (const h of hexes) {
      if (stops[stops.length - 1] !== h) {
        stops.push(h);
      }
    }
  }
  return stops;
}

/**
 * CSS `linear-gradient(180deg, …)` for the 1→0 scale bar (high index at top).
 */
export function buildMapIndexScaleBarGradient(selectedIndexValue: string): string {
  const stops = hexStopsFromLegendItems(legendRowsForIndex(selectedIndexValue));
  if (stops.length < 2) {
    return DEFAULT_GRADIENT;
  }
  const topToBottom = [...stops].reverse();
  return `linear-gradient(180deg, ${topToBottom.join(', ')})`;
}
